import React, { useEffect, useState } from "react";
import { FaSyncAlt, FaFileInvoice, FaReceipt, FaBox, FaMoneyBillWave, FaMoneyCheckAlt, FaChartPie, FaList, FaRegListAlt  } from "react-icons/fa";
import axios from "axios";
import html2pdf from "html2pdf.js";

const MonthlyReport = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [meta, setMeta] = useState({});
  const [outlets, setOutlets] = useState([]);

  const [filters, setFilters] = useState({
    outlet_id: "",
    start_year_month: "",
    end_year_month: "",
    page: 1,
    per_page: 2,
  });

  const role = localStorage.getItem("role");
  const token = localStorage.getItem("token");
  const storedOutletId = localStorage.getItem("id_outlet");

  useEffect(() => {
    if (role === "manager") {
      setFilters((prev) => ({ ...prev, outlet_id: storedOutletId }));
    } else if (role === "owner") {
      fetchOutlets();
    }
  }, [role]);

  useEffect(() => {
    if (filters.outlet_id) fetchReports();
  }, [filters]);

  const fetchOutlets = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOutlets(res.data.data);
    } catch (err) {
      console.error("Error fetching outlets", err);
    }
  };

  const fetchReports = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page: filters.page.toString(),
        per_page: filters.per_page.toString(),
      }).toString();

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/report/monthly-report?${queryParams}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setReports(res.data.data || []);
      setMeta(res.data.meta || {});
    } catch (err) {
      console.error("Error fetching reports", err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: name === "per_page" || name === "page" ? parseInt(value, 10) : value,
      ...(name !== "page" && { page: 1 }),
    }));
  };

  const formatMonth = (year, month) => {
    return `${year}-${month.toString().padStart(2, "0")}`;
  };

  const handleDownloadPDF = () => {
    const element = document.getElementById("printable-report");

    const opt = {
      margin: 0.3,
      filename: `monthly-report-${filters.start_year_month}_to_${filters.end_year_month}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };

    html2pdf()
      .from(element)
      .set(opt)
      .save()
      .then(() => {});
  };

  return (
  <div className="p-6 bg-white to-green-50 min-h-screen rounded-2xl">
       {/* Breadcrumb */}
             <nav className="text-gray-500 text-sm mb-3">
               <ol className="flex items-center gap-2">
                 <li className="hover:text-gray-700 transition">Detailed Report</li>
                 <li>/</li>
                 <li className="text-gray-700 font-medium">Monthly Report</li>
               </ol>
             </nav>
       {/* Title */}
       <h2 className="text-3xl font-bold text-gray-800 mb-4 tracking-tight flex items-center gap-2">
               <span className="text-green-600 text-3xl"> 
                 <div className="p-3 bg-green-100 rounded-2xl shadow-inner">
                 <FaRegListAlt className="text-green-600" />
                 </div>
                 </span> Monthly Report
                 
             </h2>
             <p className="text-gray-600">Kelola dan rekap laporan Bulanan Penjualan</p>
             <br></br>

    {/* TABS */}
    <div className="flex gap-3 mb-4">
      <button
        className={`px-6 py-2 rounded-full transition-colors duration-200 font-semibold flex items-center gap-2 ${
          activeTab === "overview" ? "bg-black text-white shadow-lg" : "bg-gray-200 hover:bg-gray-300"
        }`}
        onClick={() => setActiveTab("overview")}
      >
        <FaChartPie /> Overview
      </button>
      <button
        className={`px-6 py-2 rounded-full transition-colors duration-200 font-semibold flex items-center gap-2 ${
          activeTab === "list" ? "bg-black text-white shadow-lg" : "bg-gray-200 hover:bg-gray-300"
        }`}
        onClick={() => setActiveTab("list")}
      >
        <FaList /> List
      </button>
    </div>

    {/* HEADER + PDF BUTTON */}
    <div className="flex justify-between items-center mb-4">
      <h1 className="text-2xl font-bold text-gray-800">Monthly Report</h1>
      {activeTab === "list" && (
        <button
          onClick={handleDownloadPDF}
          className="flex items-center gap-2 px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg transition transform active:scale-95"
        >
          <FaFileInvoice /> Download PDF
        </button>
      )}
    </div>

    {/* FILTER PANEL */}
    <div className="flex flex-wrap gap-3 mb-6 items-center bg-white p-6 rounded-2xl shadow-xl">
      {role === "owner" && (
        <select
          name="outlet_id"
          value={filters.outlet_id}
          onChange={handleChange}
          className="border border-gray-300 bg-white px-4 py-2 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400"
        >
          <option value="">Pilih Outlet</option>
          {outlets.map((outlet) => (
            <option key={outlet.id} value={outlet.id}>
              {outlet.name}
            </option>
          ))}
        </select>
      )}
      <input
        type="month"
        name="start_year_month"
        value={filters.start_year_month}
        onChange={handleChange}
        className="border border-gray-300 bg-white px-4 py-2 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
      <input
        type="month"
        name="end_year_month"
        value={filters.end_year_month}
        onChange={handleChange}
        className="border border-gray-300 bg-white px-4 py-2 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
      <select
        name="per_page"
        value={filters.per_page}
        onChange={handleChange}
        className="border border-gray-300 bg-white px-4 py-2 rounded-full shadow-md focus:outline-none focus:ring-2 focus:ring-blue-400"
      >
        <option value={2}>2 per page</option>
        <option value={5}>5 per page</option>
        <option value={10}>10 per page</option>
      </select>
      <button
        onClick={fetchReports}
        className="flex items-center gap-2 px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg transition transform active:scale-95"
      >
        <FaSyncAlt /> Refresh
      </button>
    </div>

    {/* CONTENT */}
    {loading ? (
      <p className="text-gray-500 text-center">Loading...</p>
    ) : (
      <div className="space-y-6">

        {/* OVERVIEW TAB */}
        {activeTab === "overview" && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {reports.map((report, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-2xl shadow-xl transition hover:shadow-2xl"
              >
                <h2 className="text-lg font-semibold mb-4 text-gray-800">
                  {formatMonth(report.year, report.month)}
                </h2>
                <div className="flex flex-col md:flex-row justify-between flex-wrap gap-4 text-sm text-gray-700">
                  <div className="space-y-2">
                    <p><FaReceipt className="inline mr-2 text-blue-600" /> Transaksi: {report.total_transaction}</p>
                    <p><FaFileInvoice className="inline mr-2 text-purple-600" /> Invoice: {report.total_invoices}</p>
                    <p><FaBox className="inline mr-2 text-yellow-600" /> PO: {report.total_purchase_order}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-gray-600">Top Transaksi:</p>
                    <p className="font-semibold text-blue-700">
                      Rp {report.top_transaction.toLocaleString("id-ID")}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-green-600 font-medium">Pemasukan:</p>
                    <p className="font-bold text-green-600">
                      <FaMoneyBillWave className="inline mr-2" />
                      Rp {report.total_pemasukan.toLocaleString("id-ID")}
                    </p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-red-600 font-medium">Pengeluaran:</p>
                    <p className="font-bold text-red-600">
                      <FaMoneyCheckAlt className="inline mr-2" />
                      Rp {report.total_pengeluaran.toLocaleString("id-ID")}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* LIST TAB */}
        <div id="printable-report" className={activeTab !== "list" ? "hidden" : ""}>
          <div className="text-center mb-4">
            <h2 className="text-xl font-bold">Monthly Report</h2>
            <p>{role === "owner"
              ? outlets.find((o) => o.id.toString() === filters.outlet_id)?.name || ""
              : "Outlet ID: " + storedOutletId}</p>
            <p>Periode: {filters.start_year_month} s/d {filters.end_year_month}</p>
          </div>

          <div className="overflow-x-auto rounded-2xl shadow-xl border border-gray-300">
            <table className="w-full text-left text-sm">
              <thead className="bg-green-200 text-gray-800">
                <tr>
                  <th className="p-3">Periode</th>
                  <th className="p-3">Transaksi</th>
                  <th className="p-3">Invoice</th>
                  <th className="p-3">PO</th>
                  <th className="p-3">Top Transaksi</th>
                  <th className="p-3">Pemasukan</th>
                  <th className="p-3">Pengeluaran</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report, index) => (
                  <tr
                    key={index}
                    className={`border-t ${index % 2 === 0 ? "bg-white" : "bg-gray-50"} hover:bg-gray-100 transition`}
                  >
                    <td className="p-3">{formatMonth(report.year, report.month)}</td>
                    <td className="p-3">{report.total_transaction}</td>
                    <td className="p-3">{report.total_invoices}</td>
                    <td className="p-3">{report.total_purchase_order}</td>
                    <td className="p-3">Rp {report.top_transaction.toLocaleString("id-ID")}</td>
                    <td className="p-3 text-green-700">Rp {report.total_pemasukan.toLocaleString("id-ID")}</td>
                    <td className="p-3 text-red-700">Rp {report.total_pengeluaran.toLocaleString("id-ID")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    )}
  </div>
);

};

export default MonthlyReport;
